(function () {
  const MENU_ITEMS = [
    { label: 'Home', configKey: 'optHome', defaultIcon: 'home', materialOutlined: 'home_outlined', materialFilled: 'home_filled' },
    { label: 'Promoções', configKey: 'optPromocoes', defaultIcon: 'sale', materialOutlined: 'loyalty_outlined', materialFilled: 'loyalty' },
    { label: 'Sacola', configKey: 'optSacola', defaultIcon: 'bag', materialOutlined: 'shopping_bag_outlined', materialFilled: 'shopping_bag' },
    { label: 'Buscar', configKey: 'optBuscar', defaultIcon: 'search', materialOutlined: 'search', materialFilled: 'pageview' },
    { label: 'Contato', configKey: 'optContato', defaultIcon: 'chat', materialOutlined: 'chat_outlined', materialFilled: 'chat' },
    { label: 'Perfil', configKey: 'optPerfil', defaultIcon: 'profile', materialOutlined: 'person_outline', materialFilled: 'person_rounded' },
    { label: 'Carrinho', configKey: 'optCarrinho', defaultIcon: 'cart', materialOutlined: 'shopping_cart_outlined', materialFilled: 'shopping_cart' },
    { label: 'Rastreio', configKey: 'optRastreio', defaultIcon: 'truck', materialOutlined: 'location_on_outlined', materialFilled: 'location_on' },
    { label: 'Novidades', configKey: 'optNovidades', defaultIcon: 'newsPlus', materialOutlined: 'electric_bolt_sharp', materialFilled: 'electric_bolt_rounded' },
    { label: 'Categorias', configKey: 'optCategorias', defaultIcon: 'category', materialOutlined: 'grid_view_outlined', materialFilled: 'grid_view_rounded' },
    { label: 'Stories', configKey: 'optStories', defaultIcon: 'playVideo', materialOutlined: 'slow_motion_video_outlined', materialFilled: 'slow_motion_video_outlined' },
    { label: 'Pontos', configKey: 'optPontos', defaultIcon: 'cash', materialOutlined: 'savings_outlined', materialFilled: 'savings' },
    { label: 'Desejos', configKey: 'optDesejos', defaultIcon: 'heart', materialOutlined: 'auto_awesome_outlined', materialFilled: 'auto_awesome' },
    { label: 'Kits', configKey: 'optKits', defaultIcon: 'box', materialOutlined: 'shopping_basket_outlined', materialFilled: 'shopping_basket_rounded' },
    { label: 'Cupons', configKey: 'optCupons', defaultIcon: 'coupon', materialOutlined: 'local_attraction_outlined', materialFilled: 'local_attraction_sharp' },
    { label: 'Produtos', configKey: 'optProdutos', defaultIcon: 'tShirt', materialOutlined: 'checkroom_outlined', materialFilled: 'checkroom' },
    { label: 'Departamentos', configKey: 'optDepartamentos', defaultIcon: 'list', materialOutlined: 'list', materialFilled: 'format_list_bulleted' },
    { label: 'Atendimento', configKey: 'optAtendimento', defaultIcon: 'headset', materialOutlined: 'headset_mic_outlined', materialFilled: 'headset_mic' },
    { label: 'Blog', configKey: 'optBlog', defaultIcon: 'book', materialOutlined: 'menu_book_outlined', materialFilled: 'menu_book' },
    { label: 'Social', configKey: 'optSocial', defaultIcon: 'instagram', materialOutlined: 'perm_media_outlined', materialFilled: 'perm_media_sharp' },
    { label: 'Menu', configKey: 'optMenu', defaultIcon: 'list', materialOutlined: 'list', materialFilled: 'format_list_bulleted' },
  ];

  const MENU_ITEM_BY_LABEL = Object.fromEntries(MENU_ITEMS.map((item) => [item.label, item]));
  const LEGACY_LABEL_ALIASES = {
    'Promo\u00C3\u00A7\u00C3\u00B5es': 'Promoções',
  };

  const MATERIAL_ICONS = {
    home_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f107' },
    home_filled: { fontFamily: 'MaterialIcons', codepoint: 'e319' },
    loyalty_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f1a4' },
    loyalty: { fontFamily: 'MaterialIcons', codepoint: 'e3be' },
    shopping_bag_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f37d' },
    shopping_bag: { fontFamily: 'MaterialIcons', codepoint: 'e59a' },
    search: { fontFamily: 'MaterialIcons', codepoint: 'e567' },
    pageview: { fontFamily: 'MaterialIcons', codepoint: 'e469' },
    chat_outlined: { fontFamily: 'MaterialIcons', codepoint: 'ef44' },
    chat: { fontFamily: 'MaterialIcons', codepoint: 'e153' },
    person_outline: { fontFamily: 'MaterialIcons', codepoint: 'e497' },
    person_rounded: { fontFamily: 'MaterialIcons', codepoint: 'f0071' },
    shopping_cart_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f37f' },
    shopping_cart: { fontFamily: 'MaterialIcons', codepoint: 'e59c' },
    location_on_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f193' },
    location_on: { fontFamily: 'MaterialIcons', codepoint: 'e3ab' },
    electric_bolt_sharp: { fontFamily: 'MaterialIcons', codepoint: 'f0744' },
    electric_bolt_rounded: { fontFamily: 'MaterialIcons', codepoint: 'f07f4' },
    grid_view_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f0d7' },
    grid_view_rounded: { fontFamily: 'MaterialIcons', codepoint: 'f7c4' },
    slow_motion_video_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f3a4' },
    savings_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f336' },
    savings: { fontFamily: 'MaterialIcons', codepoint: 'e553' },
    auto_awesome_outlined: { fontFamily: 'MaterialIcons', codepoint: 'eea9' },
    auto_awesome: { fontFamily: 'MaterialIcons', codepoint: 'e0b7' },
    shopping_basket_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f37e' },
    shopping_basket_rounded: { fontFamily: 'MaterialIcons', codepoint: 'f0170' },
    local_attraction_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f171' },
    local_attraction_sharp: { fontFamily: 'MaterialIcons', codepoint: 'ea83' },
    checkroom_outlined: { fontFamily: 'MaterialIcons', codepoint: 'ef4c' },
    checkroom: { fontFamily: 'MaterialIcons', codepoint: 'e15d' },
    list: { fontFamily: 'MaterialIcons', codepoint: 'e896' },
    format_list_bulleted: { fontFamily: 'MaterialIcons', codepoint: 'e2b8' },
    headset_mic_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f0ee' },
    headset_mic: { fontFamily: 'MaterialIcons', codepoint: 'e302' },
    menu_book_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f1c2' },
    menu_book: { fontFamily: 'MaterialIcons', codepoint: 'e3dd' },
    perm_media_outlined: { fontFamily: 'MaterialIcons', codepoint: 'f272' },
    perm_media_sharp: { fontFamily: 'MaterialIcons', codepoint: 'eb85' },
  };

  const PHOSPHOR_VARIANTS = [
    { id: 'regular', label: 'Regular' },
    { id: 'bold', label: 'Bold' },
    { id: 'light', label: 'Light' },
    { id: 'thin', label: 'Thin' },
    { id: 'fill', label: 'Fill' },
    { id: 'duotone', label: 'Duotone' },
  ];

  const THEME_FAMILIES = [
    {
      id: 'material-outline',
      label: 'Contorno',
      //description: 'Coleção nativa do app em contorno. Mantém os ícones padrão dessa proposta visual.',
      summaryKey: null,
      supportsCustomIcons: false,
    },
    {
      id: 'material-filled',
      label: 'Preenchido',
      //description: 'Coleção nativa do app preenchida. Mantém os ícones padrão dessa proposta visual.',
      summaryKey: null,
      supportsCustomIcons: false,
    },
    {
      id: 'linear',
      label: 'Linear',
      //description: 'Coleção clássica do app, usando os ícones personalizados já definidos no menu.',
      summaryKey: 'linear',
      supportsCustomIcons: true,
    },
    {
      id: 'huge-twotone',
      label: 'Duo',
      //description: 'Ícones em duas camadas, com mais contraste visual no menu.',
      summaryKey: 'hugeTwotone',
      supportsCustomIcons: true,
    },
    {
      id: 'huge-bulk',
      label: 'Sólido',
      //description: 'Versão preenchida com mais massa visual nos botões do menu.',
      summaryKey: 'hugeBulk',
      supportsCustomIcons: true,
    },
    {
      id: 'phosphor',
      label: 'Versátil',
      //description: 'Nova coleção com pesos Regular, Bold, Light, Thin, Fill e Duotone.',
      summaryKey: 'phosphor',
      supportsCustomIcons: true,
    },
  ];

  const CUSTOM_THEME_FAMILIES = new Set(['linear', 'huge-twotone', 'huge-bulk', 'phosphor']);
  const APP_MENU_TAB_IDS = ['menus', 'float', 'style', 'links', 'sidebar'];
  const SIDEBAR_MIN_APP_VERSION = 260820;

  const state = {
    initialized: false,
    disabled: false,
    appVersion: 0,
    handlers: {},
    config: { menu: {} },
    floatDraft: {},
    theme: { familyId: 'linear', dark: false, variant: 'regular', value: 'linear' },
    lookups: null,
    modal: { targetKey: null, targetLabel: '', category: 'all', search: '' },
    bootstrapModal: null,
    dom: {},
    activeTab: 'menus',
    isSyncingPalette: false,
    dragObserver: null,
    headerResizeObserver: null,
  };

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function glyph(hex) {
    return String.fromCodePoint(parseInt(hex, 16));
  }

  function humanizeKey(value) {
    return String(value || '')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
      .replace(/([0-9]+)/g, ' $1 ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function clampNumber(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function getFloatBtnSize(value) {
    const raw = parseInt(value, 10);
    return Number.isFinite(raw) ? clampNumber(raw, 18, 40) : 28;
  }

  function getEffectiveMenuConfig() {
    return {
      ...(state.config.menu || {}),
      ...(state.floatDraft || {}),
    };
  }

  function normalizeTabId(value) {
    return APP_MENU_TAB_IDS.includes(value) ? value : 'menus';
  }

  function renderTabs() {
    if (!state.dom.tabButtons || !state.dom.tabPanels) {
      return;
    }

    const activeTab = normalizeTabId(state.activeTab);
    state.dom.tabButtons.forEach((button) => {
      const isActive = button.getAttribute('data-app-menu-tab') === activeTab;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.tabIndex = isActive ? 0 : -1;
    });
    state.dom.tabPanels.forEach((panel) => {
      const isActive = panel.getAttribute('data-app-menu-panel') === activeTab;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function setActiveTab(tabId) {
    state.activeTab = normalizeTabId(tabId);
    renderTabs();
  }

  function syncStickyTop() {
    if (!state.dom.root) {
      return;
    }

    const header = document.querySelector('.nk-header');
    const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 74;
    state.dom.root.style.setProperty('--app-menu-sticky-top', headerHeight + 12 + 'px');
  }

  function normalizeMenuLabel(label) {
    return LEGACY_LABEL_ALIASES[label] || label;
  }

  function getStoredAppVersion() {
    if (typeof window === 'undefined' || !window.localStorage) {
      return 0;
    }
    const raw = Number(window.localStorage.getItem('appVersion')) || 0;
    return Number.isFinite(raw) ? raw : 0;
  }

  function getAppVersion() {
    return Number(state.appVersion) || getStoredAppVersion();
  }

  function isFamilyLocked(familyId) {
    return familyId === 'phosphor' && getAppVersion() < 260308;
  }

  function isSidebarVersionSupported() {
    return getAppVersion() >= SIDEBAR_MIN_APP_VERSION;
  }

  function getCatalog() {
    return window.AppMenuIconCatalog || null;
  }

  function ensureLookups() {
    if (state.lookups) {
      return state.lookups;
    }

    const catalog = getCatalog();
    if (!catalog || !catalog.iconSets) {
      return null;
    }

    const asMap = (list) =>
      (list || []).reduce((acc, item) => {
        acc[item.key] = item;
        return acc;
      }, {});

    state.lookups = {
      catalog,
      linear: asMap(catalog.iconSets.linear),
      hugeBulk: asMap(catalog.iconSets.hugeBulk),
      hugeTwotone: asMap(catalog.iconSets.hugeTwotone),
      phosphor: {
        regular: asMap(catalog.iconSets.phosphor.regular),
        bold: asMap(catalog.iconSets.phosphor.bold),
        light: asMap(catalog.iconSets.phosphor.light),
        thin: asMap(catalog.iconSets.phosphor.thin),
        fill: asMap(catalog.iconSets.phosphor.fill),
        duotone: asMap(catalog.iconSets.phosphor.duotone),
      },
      lists: {
        linear: catalog.iconSets.linear || [],
        hugeBulk: catalog.iconSets.hugeBulk || [],
        hugeTwotone: catalog.iconSets.hugeTwotone || [],
        phosphor: catalog.iconSets.phosphor || {},
      },
    };

    return state.lookups;
  }

  function resolveTheme(themeValue) {
    const raw = String(themeValue || 'linear');
    const dark = raw.startsWith('dark');
    const theme = dark ? raw.slice(4) : raw;

    if (theme.includes('phosphor')) {
      let variant = theme.replace('phosphor', '') || 'regular';
      if (!PHOSPHOR_VARIANTS.some((item) => item.id === variant)) {
        variant = 'regular';
      }
      return {
        familyId: 'phosphor',
        dark,
        variant,
        value: raw,
      };
    }

    if (theme.includes('hugebulk')) {
      return { familyId: 'huge-bulk', dark, variant: 'regular', value: raw };
    }

    if (theme.includes('hugetwotone')) {
      return { familyId: 'huge-twotone', dark, variant: 'regular', value: raw };
    }

    if (theme.includes('linear')) {
      return { familyId: 'linear', dark, variant: 'regular', value: raw };
    }

    if (theme.includes('filled')) {
      return { familyId: 'material-filled', dark, variant: 'regular', value: raw };
    }

    return { familyId: 'material-outline', dark, variant: 'regular', value: raw };
  }

  function composeThemeValue(familyId, dark, variant) {
    switch (familyId) {
      case 'material-outline':
        return dark ? 'dark' : 'light';
      case 'material-filled':
        return dark ? 'darkfilled' : 'filled';
      case 'linear':
        return dark ? 'darklinear' : 'linear';
      case 'huge-twotone':
        return dark ? 'darkhugetwotone' : 'hugetwotone';
      case 'huge-bulk':
        return dark ? 'darkhugebulk' : 'hugebulk';
      case 'phosphor': {
        const suffix = variant && variant !== 'regular' ? 'phosphor' + variant : 'phosphor';
        return dark ? 'dark' + suffix : suffix;
      }
      default:
        return 'linear';
    }
  }

  function normalizeConfig(rawConfig) {
    const config = rawConfig && typeof rawConfig === 'object' ? { ...rawConfig } : {};
    const menu = config.menu && typeof config.menu === 'object' ? { ...config.menu } : {};

    MENU_ITEMS.forEach((item) => {
      if (!menu[item.configKey] || typeof menu[item.configKey] !== 'string') {
        menu[item.configKey] = item.defaultIcon;
      }
    });

    menu.options =
      Array.isArray(menu.options) && menu.options.length
        ? menu.options.map(normalizeMenuLabel).filter((label) => MENU_ITEM_BY_LABEL[label])
        : ['Home', 'Promoções', 'Sacola', 'Buscar'];

    if (!menu.theme) {
      menu.theme = 'linear';
    }

    config.menu = menu;
    return config;
  }

  function getFamilyById(familyId) {
    return THEME_FAMILIES.find((item) => item.id === familyId) || THEME_FAMILIES[0];
  }

  function isCustomFamily(familyId) {
    return CUSTOM_THEME_FAMILIES.has(familyId);
  }

  function getThemeInfoForFamily(familyId) {
    return {
      familyId,
      dark: state.theme.dark,
      variant: familyId === 'phosphor' ? state.theme.variant : 'regular',
      value: composeThemeValue(
        familyId,
        state.theme.dark,
        familyId === 'phosphor' ? state.theme.variant : 'regular'
      ),
    };
  }

  function getCurrentMenuLabels() {
    if (state.dom.basicRight) {
      const labels = Array.from(state.dom.basicRight.querySelectorAll('[data-menu-label]'))
        .map((node) => node.getAttribute('data-menu-label'))
        .filter(Boolean);
      if (labels.length) {
        return labels;
      }
    }
    return (state.config.menu.options || []).filter((label) => MENU_ITEM_BY_LABEL[label]);
  }

  function isFloatBtnEligible(labels) {
    const items = Array.isArray(labels) ? labels : getCurrentMenuLabels();
    return items.length === 5;
  }

  function getMenuIconKey(label) {
    const item = MENU_ITEM_BY_LABEL[label];
    if (!item) {
      return 'gift';
    }
    return state.config.menu[item.configKey] || item.defaultIcon;
  }

  function getFamilyList(themeInfo) {
    const lookups = ensureLookups();
    if (!lookups) {
      return [];
    }

    switch (themeInfo.familyId) {
      case 'linear':
        return lookups.lists.linear;
      case 'huge-bulk':
        return lookups.lists.hugeBulk;
      case 'huge-twotone':
        return lookups.lists.hugeTwotone;
      case 'phosphor':
        return lookups.lists.phosphor[themeInfo.variant] || [];
      default:
        return [];
    }
  }

  function lookupFamilyIcon(themeInfo, iconKey) {
    const lookups = ensureLookups();
    if (!lookups) {
      return null;
    }

    switch (themeInfo.familyId) {
      case 'linear':
        return lookups.linear[iconKey] || null;
      case 'huge-bulk':
        return lookups.hugeBulk[iconKey] || null;
      case 'huge-twotone':
        return lookups.hugeTwotone[iconKey] || null;
      case 'phosphor':
        return lookups.phosphor[themeInfo.variant][iconKey] || null;
      default:
        return null;
    }
  }

  function normalizeMaterialDescriptor(name) {
    const icon = MATERIAL_ICONS[name] || MATERIAL_ICONS.home_outlined;
    return {
      type: 'single',
      fontFamily: icon.fontFamily,
      codepoint: icon.codepoint,
      resolvedKey: name,
      fallback: false,
    };
  }

  function normalizeCatalogDescriptor(themeInfo, icon, requestedKey, fallback) {
    if (!icon) {
      return normalizeMaterialDescriptor('home_outlined');
    }

    if (themeInfo.familyId === 'linear') {
      return {
        type: 'single',
        fontFamily: icon.fontFamily,
        codepoint: icon.codepoint,
        resolvedKey: requestedKey,
        fallback,
      };
    }

    if (themeInfo.familyId === 'huge-bulk' || themeInfo.familyId === 'huge-twotone') {
      return {
        type: 'layered',
        fontFamily: icon.fontFamily,
        primary: icon.before,
        secondary: icon.after,
        resolvedKey: requestedKey,
        fallback,
      };
    }

    if (themeInfo.familyId === 'phosphor' && themeInfo.variant === 'duotone') {
      return {
        type: 'layered',
        fontFamily: icon.fontFamily,
        primary: icon.primary,
        secondary: icon.secondary,
        resolvedKey: requestedKey,
        fallback,
      };
    }

    return {
      type: 'single',
      fontFamily: icon.fontFamily,
      codepoint: icon.codepoint,
      resolvedKey: requestedKey,
      fallback,
    };
  }

  function getDescriptorForIconKey(themeInfo, iconKey) {
    let entry = lookupFamilyIcon(themeInfo, iconKey);
    if (entry) {
      return normalizeCatalogDescriptor(themeInfo, entry, iconKey, false);
    }

    entry = lookupFamilyIcon(themeInfo, 'gift');
    return normalizeCatalogDescriptor(themeInfo, entry, iconKey, true);
  }

  function getDescriptorForMenu(label, themeInfo, iconKey) {
    const menuItem = MENU_ITEM_BY_LABEL[label];
    if (!menuItem) {
      return normalizeMaterialDescriptor('home_outlined');
    }

    if (themeInfo.familyId === 'material-outline') {
      return normalizeMaterialDescriptor(menuItem.materialOutlined);
    }

    if (themeInfo.familyId === 'material-filled') {
      return normalizeMaterialDescriptor(menuItem.materialFilled);
    }

    return getDescriptorForIconKey(themeInfo, iconKey);
  }

  function getFloatDescriptor(themeInfo, floatLabel) {
    const menuConfig = getEffectiveMenuConfig();
    const floatKey = menuConfig.floatBtnIcon;
    if (!floatKey) {
      return getDescriptorForMenu(floatLabel, themeInfo, getMenuIconKey(floatLabel));
    }

    if (
      themeInfo.familyId === 'linear' ||
      themeInfo.familyId === 'phosphor' ||
      themeInfo.familyId === 'huge-bulk' ||
      themeInfo.familyId === 'huge-twotone'
    ) {
      return getDescriptorForIconKey(themeInfo, floatKey);
    }

    return getDescriptorForIconKey({ familyId: 'huge-bulk', dark: false, variant: 'regular' }, floatKey);
  }

  function getFloatPreviewLabel(labels) {
    const currentLabels = Array.isArray(labels) ? labels : getCurrentMenuLabels();
    if (currentLabels[2]) {
      return currentLabels[2];
    }
    if (currentLabels[0]) {
      return currentLabels[0];
    }
    return 'Home';
  }

  function getFloatIconThemeInfo() {
    if (
      state.theme.familyId === 'linear' ||
      state.theme.familyId === 'phosphor' ||
      state.theme.familyId === 'huge-bulk' ||
      state.theme.familyId === 'huge-twotone'
    ) {
      return state.theme;
    }

    return {
      familyId: 'huge-bulk',
      dark: false,
      variant: 'regular',
      value: 'hugebulk',
    };
  }

  function renderFloatIconSelect() {
    if (!state.dom.floatBtnIconSelect) {
      return;
    }

    const menuConfig = getEffectiveMenuConfig();
    const themeInfo = getFloatIconThemeInfo();
    const list = getFamilyList(themeInfo);
    const currentKey = String(menuConfig.floatBtnIcon || '');
    const grouped = list.reduce((acc, item) => {
      const groupKey = item.category || 'Outros';
      if (!acc[groupKey]) {
        acc[groupKey] = [];
      }
      acc[groupKey].push(item);
      return acc;
    }, {});
    const hasCurrent = !!currentKey && list.some((item) => item.key === currentKey);
    const groupedOptions = Object.keys(grouped).map((category) => {
      return [
        '<optgroup label="',
        escapeHtml(category),
        '">',
        grouped[category]
          .map((item) => {
            return (
              '<option value="' +
              escapeHtml(item.key) +
              '">' +
              escapeHtml(humanizeKey(item.key)) +
              '</option>'
            );
          })
          .join(''),
        '</optgroup>',
      ].join('');
    });
    const unsupportedOption =
      currentKey && !hasCurrent
        ? '<option value="' +
          escapeHtml(currentKey) +
          '">' +
          escapeHtml(humanizeKey(currentKey)) +
          ' (indisponível nesta coleção)</option>'
        : '';

    state.dom.floatBtnIconSelect.innerHTML = [
      '<option value="">Ícone do item central</option>',
      unsupportedOption,
      groupedOptions.join(''),
    ].join('');
    state.dom.floatBtnIconSelect.value = currentKey || '';
  }

  function renderIconMarkup(descriptor) {
    if (!descriptor) {
      return '';
    }

    if (descriptor.type === 'layered') {
      return [
        '<span class="app-menu-icon app-menu-icon--stack">',
        '<span class="app-menu-icon__layer app-menu-icon__layer--secondary" style="font-family:',
        escapeHtml(descriptor.fontFamily),
        ';">',
        glyph(descriptor.secondary),
        '</span>',
        '<span class="app-menu-icon__layer app-menu-icon__layer--primary" style="font-family:',
        escapeHtml(descriptor.fontFamily),
        ';">',
        glyph(descriptor.primary),
        '</span>',
        '</span>',
      ].join('');
    }

    return [
      '<span class="app-menu-icon app-menu-icon--single">',
      '<span class="app-menu-icon__glyph" style="font-family:',
      escapeHtml(descriptor.fontFamily),
      ';">',
      glyph(descriptor.codepoint),
      '</span>',
      '</span>',
    ].join('');
  }

  function countUnsupportedIcons(themeInfo, labels) {
    if (!isCustomFamily(themeInfo.familyId)) {
      return 0;
    }
    return labels.reduce((count, label) => count + (lookupFamilyIcon(themeInfo, getMenuIconKey(label)) ? 0 : 1), 0);
  }

  function buildPhonePreview(themeInfo) {
    const labels = getCurrentMenuLabels();
    const menuConfig = getEffectiveMenuConfig();
    const floatIndex = menuConfig.floatBtnIndex === 2 && isFloatBtnEligible(labels) ? 2 : -1;
    const navItems = labels
      .map((label, index) => {
        const descriptor = getDescriptorForMenu(label, themeInfo, getMenuIconKey(label));
        return [
          '<div class="app-menu-preview-item">',
          renderIconMarkup(descriptor),
          '<span class="app-menu-preview-item__label">',
          index === floatIndex ? '&nbsp;' : escapeHtml(label),
          '</span>',
          '</div>',
        ].join('');
      })
      .join('');

    let fab = '';
    if (floatIndex >= 0) {
      const floatLabel = labels[floatIndex];
      const floatDescriptor = getFloatDescriptor(themeInfo, floatLabel);
      const backColor = menuConfig.floatBtnBackColor || '#16364f';
      const textColor = menuConfig.floatBtnTextColor || '#ffffff';
      const floatBtnSize = getFloatBtnSize(menuConfig.floatBtnSize);
      const floatBtnText = String(menuConfig.floatBtnText || '').slice(0, 12);
      const floatText = floatBtnText
        ? '<span class="app-menu-preview-fab__label">' + escapeHtml(floatBtnText) + '</span>'
        : '';
      fab = [
        '<div class="app-menu-preview-fab ',
        floatBtnText ? 'has-label ' : '',
        state.config.menu.floatBtnCircular ? 'is-circular' : '',
        '" style="background:',
        escapeHtml(backColor),
        '; color:',
        escapeHtml(textColor),
        '; --app-menu-fab-icon-size:',
        floatBtnSize,
        'px;',
        ';">',
        '<div class="app-menu-preview-fab__content" style="--app-menu-fab-icon-size:',
        floatBtnSize,
        'px;">',
        '<span class="app-menu-preview-fab__icon">',
        renderIconMarkup(floatDescriptor),
        '</span>',
        floatText,
        '</div>',
        '</div>',
      ].join('');
    }

    return [
      '<div class="app-menu-preview-phone ',
      themeInfo.dark ? 'is-dark' : '',
      '">',
      '<div class="app-menu-preview-phone__screen"></div>',
      '<span class="app-menu-preview-phone__label">Prévia fiel do app</span>',
      fab,
      '<div class="app-menu-preview-nav">',
      navItems,
      '</div>',
      '</div>',
    ].join('');
  }

  function renderFloatButtonCardPreview() {
    if (!state.dom.floatBtnPreview || !state.dom.floatBtnPreviewIcon) {
      return;
    }

    const labels = getCurrentMenuLabels();
    const menuConfig = getEffectiveMenuConfig();
    const floatLabel = getFloatPreviewLabel(labels);
    const descriptor = getFloatDescriptor(state.theme, floatLabel);
    const backColor = menuConfig.floatBtnBackColor || '#000000';
    const textColor = menuConfig.floatBtnTextColor || '#ffffff';
    const floatBtnText = String(menuConfig.floatBtnText || '').slice(0, 12);
    const previewSize = getFloatBtnSize(menuConfig.floatBtnSize) + 5;

    state.dom.floatBtnPreview.style.backgroundColor = backColor;
    state.dom.floatBtnPreview.style.color = textColor;
    state.dom.floatBtnPreview.style.setProperty('--float-btn-icon-size', previewSize + 'px');
    state.dom.floatBtnPreview.style.borderRadius = menuConfig.floatBtnCircular ? '50%' : '10%';
    state.dom.floatBtnPreview.classList.toggle('has-label', !!floatBtnText);
    state.dom.floatBtnPreviewIcon.innerHTML = renderIconMarkup(descriptor);

    if (state.dom.floatBtnPreviewText) {
      state.dom.floatBtnPreviewText.textContent = floatBtnText;
      state.dom.floatBtnPreviewText.hidden = !floatBtnText;
      state.dom.floatBtnPreviewText.style.color = textColor;
    }
  }

  function createActiveBadge() {
    const badge = document.createElement('span');
    badge.className = 'pricing-badge badge bg-primary app-menu-palette__badge';
    badge.textContent = 'Ativos';
    return badge;
  }

  function syncPalette(options) {
    const left = state.dom.basicLeft;
    const right = state.dom.basicRight;
    if (!left || !right) {
      return;
    }

    const labels = options
      .map(normalizeMenuLabel)
      .filter((label) => MENU_ITEM_BY_LABEL[label]);
    const nodes = {};
    Array.from(left.querySelectorAll('[data-menu-label]')).forEach((node) => {
      nodes[node.getAttribute('data-menu-label')] = node;
    });
    Array.from(right.querySelectorAll('[data-menu-label]')).forEach((node) => {
      nodes[node.getAttribute('data-menu-label')] = node;
    });

    state.isSyncingPalette = true;
    right.innerHTML = '';
    right.appendChild(createActiveBadge());

    labels.forEach((label) => {
      if (nodes[label]) {
        right.appendChild(nodes[label]);
      }
    });

    MENU_ITEMS.forEach((item) => {
      if (!labels.includes(item.label) && nodes[item.label]) {
        left.appendChild(nodes[item.label]);
      }
    });

    state.isSyncingPalette = false;
  }

  function renderPaletteItems() {
    [state.dom.basicLeft, state.dom.basicRight].forEach((container) => {
      if (!container) {
        return;
      }

      Array.from(container.querySelectorAll('[data-menu-label]')).forEach((node) => {
        const label = node.getAttribute('data-menu-label');
        const descriptor = getDescriptorForMenu(label, state.theme, getMenuIconKey(label));
        const blocked = node.classList.contains('drag-blocked');
        const sidebarPreviewOnly = label === 'Menu' && !isSidebarVersionSupported();
        const flag = blocked
          ? '<span class="app-menu-drag-item__flag">Plano necessario</span>'
          : sidebarPreviewOnly
            ? '<span class="app-menu-drag-item__flag">Requer atualização</span>'
            : '';
        node.innerHTML = [
          '<div class="app-menu-drag-item__main">',
          '<span class="app-menu-drag-item__icon">',
          renderIconMarkup(descriptor),
          '</span>',
          '<span class="app-menu-drag-item__label">',
          escapeHtml(label),
          '</span>',
          '</div>',
          flag,
        ].join('');
      });
    });
  }

  function renderSummaryBadges() {
    const lookups = ensureLookups();
    if (!lookups || !state.dom.catalogSummary) {
      return;
    }

    const summary = lookups.catalog.summary;
    state.dom.catalogSummary.innerHTML = [
      '<span class="app-menu-summary-badge">Linear: ',
      summary.linear,
      '</span>',
      '<span class="app-menu-summary-badge">Sólido: ',
      summary.hugeBulk,
      '</span>',
      '<span class="app-menu-summary-badge">Duo: ',
      summary.hugeTwotone,
      '</span>',
      '<span class="app-menu-summary-badge">Versátil: ',
      summary.phosphor,
      '</span>',
    ].join('');
  }

  function renderThemeControls() {
    if (state.dom.darkToggle) {
      state.dom.darkToggle.checked = !!state.theme.dark;
      state.dom.darkToggle.disabled = state.disabled;
    }

    if (state.dom.currentThemeMeta) {
      const family = getFamilyById(state.theme.familyId);
      const modeLabel = state.theme.dark ? 'Escuro' : 'Claro';
      const variantLabel =
        state.theme.familyId === 'phosphor'
          ? PHOSPHOR_VARIANTS.find((item) => item.id === state.theme.variant).label
          : 'Padrão';
      const lockedChip = isFamilyLocked(state.theme.familyId)
        ? '<span class="app-menu-chip is-warning">Atualize o app para usar essa coleção</span>'
        : '';
      state.dom.currentThemeMeta.innerHTML = [
        '<span class="app-menu-chip">Tema salvo: ',
        escapeHtml(family.label),
        '</span>',
        '<span class="app-menu-chip">Modo: ',
        escapeHtml(modeLabel),
        '</span>',
        state.theme.familyId === 'phosphor'
          ? '<span class="app-menu-chip">Peso: ' + escapeHtml(variantLabel) + '</span>'
          : '',
        lockedChip,
      ].join('');
    }

  }

  function buildPhosphorVariantControls(locked) {
    return [
      '<div class="app-menu-theme-card__divider"></div>',
      '<div class="app-menu-theme-card__variants">',
      '<div class="app-menu-theme-card__variants-head">',
      '<hr style="width:100%;"></div>',
      '<div class="app-menu-theme-card__variant-list">',
      PHOSPHOR_VARIANTS.map((variant) => {
        const active = state.theme.familyId === 'phosphor' && variant.id === state.theme.variant;
        return [
          '<button type="button" class="app-menu-chip is-interactive ',
          active ? 'is-active' : '',
          '" data-phosphor-variant="',
          escapeHtml(variant.id),
          '" ',
          state.disabled || locked ? 'disabled' : '',
          '>',
          escapeHtml(variant.label),
          '</button>',
        ].join('');
      }).join(''),
      '</div>',
      '</div>',
    ].join('');
  }

  function renderThemeCards() {
    if (!state.dom.themeFamilyGrid) {
      return;
    }

    const lookups = ensureLookups();
    const summary = lookups ? lookups.catalog.summary : {};
    const labels = getCurrentMenuLabels();

    state.dom.themeFamilyGrid.innerHTML = THEME_FAMILIES.map((family) => {
      const themeInfo = getThemeInfoForFamily(family.id);
      const unsupported = countUnsupportedIcons(themeInfo, labels);
      const locked = isFamilyLocked(family.id);
      const countLabel = family.summaryKey ? summary[family.summaryKey] + ' ícones' : labels.length + ' botões fixos';
      const footerText = locked
        ? 'Requer uma atualização no app'
        : family.supportsCustomIcons
        ? unsupported > 0
          ? unsupported + ' ícone(s) serão trocados pelo padrão nessa coleção'
          : 'Todos os ícones ativos existem nessa coleção'
        : 'Coleção fixa';
      const overlay = locked
        ? '<div class="app-menu-theme-card__overlay"><div><strong>Atualize o app</strong><p>Essa coleção precisa de uma atualização no app para funcionar.</p></div></div>'
        : '';
      const phosphorControls = family.id === 'phosphor' ? buildPhosphorVariantControls(locked) : '';

      return [
        '<article class="app-menu-theme-card ',
        family.id === state.theme.familyId ? 'is-selected ' : '',
        state.disabled ? 'is-disabled ' : '',
        locked ? 'is-locked' : '',
        '" data-theme-family="',
        escapeHtml(family.id),
        '">',
        '<div class="app-menu-theme-card__meta">',
        '<div>',
        '<h6>',
        escapeHtml(family.label),
        '</h6>',
        '<p>',
        escapeHtml(family.description),
        '</p>',
        '</div>',
        '<span class="app-menu-theme-card__badge">',
        escapeHtml(countLabel),
        '</span>',
        '</div>',
        buildPhonePreview(themeInfo),
        overlay,
        '<div class="app-menu-theme-card__footer">',
        '<span class="app-menu-theme-card__status ',
        unsupported > 0 || locked ? 'app-menu-theme-card__warning' : '',
        '">',
        escapeHtml(footerText),
        '</span>',
        '<span class="app-menu-chip">',
        locked ? 'Atualize o app' : family.id === state.theme.familyId ? 'Selecionado' : 'Usar',
        '</span>',
        '</div>',
        phosphorControls,
        '</article>',
      ].join('');
    }).join('');
  }

  function renderPreviewStage() {
    if (!state.dom.previewStage) {
      return;
    }

    const family = getFamilyById(state.theme.familyId);
    const unsupported = countUnsupportedIcons(state.theme, getCurrentMenuLabels());
    const locked = isFamilyLocked(state.theme.familyId);

    state.dom.previewStage.innerHTML = [
      '<div class="app-menu-preview-stage__head">',
      '<div>',
      '<h6>Prévia do menu salvo no app</h6>',
      '</div>',
      '<div class="app-menu-preview-stage__legend">',
      '<span class="app-menu-chip">',
      escapeHtml(family.label),
      '</span>',
      '<span class="app-menu-chip">',
      state.theme.dark ? 'Escuro' : 'Claro',
      '</span>',
      state.theme.familyId === 'phosphor'
        ? '<span class="app-menu-chip">' + escapeHtml(PHOSPHOR_VARIANTS.find((item) => item.id === state.theme.variant).label) + '</span>'
        : '',
      unsupported > 0
        ? '<span class="app-menu-chip is-warning">' + unsupported + ' substituição(ões) pelo ícone padrão</span>'
        : '',
      locked
        ? '<span class="app-menu-chip is-warning">Atualize o app para publicar essa coleção</span>'
        : '',
      '</div>',
      '</div>',
      buildPhonePreview(state.theme),
    ].join('');
  }

  function renderMenuIconCards() {
    if (!state.dom.menuIconEditor) {
      return;
    }

    const labels = getCurrentMenuLabels();
    if (!labels.length) {
      state.dom.menuIconEditor.innerHTML =
        '<div class="app-menu-empty">Arraste de 4 a 6 itens para o lado direito para montar o menu e liberar os editores de ícone.</div>';
      return;
    }

    state.dom.menuIconEditor.innerHTML = labels
      .map((label) => {
        const item = MENU_ITEM_BY_LABEL[label];
        const iconKey = getMenuIconKey(label);
        const descriptor = getDescriptorForMenu(label, state.theme, iconKey);
        const locked = isFamilyLocked(state.theme.familyId);
        const canEdit = !state.disabled && isCustomFamily(state.theme.familyId) && !locked;
        const supported = isCustomFamily(state.theme.familyId) ? !!lookupFamilyIcon(state.theme, iconKey) : true;
        const statusClass = supported && !locked ? 'is-ok' : 'is-warning';
        const statusText = locked
          ? 'Atualize o app para editar nessa coleção'
          : !isCustomFamily(state.theme.familyId)
          ? 'Tema atual usa ícone fixo'
          : supported
          ? 'Ícone disponível<br>nessa coleção'
          : 'Não existe nessa coleção, o app usa o ícone padrão';

        return [
          '<article class="app-menu-editor-card">',
          '<div class="app-menu-editor-card__head">',
          '<div>',
          '<h6>',
          escapeHtml(label),
          '</h6>',
          '</div>',
          '<span class="app-menu-editor-card__status ',
          statusClass,
          '">',
          statusText,
          '</span>',
          '</div>',
          '<div class="app-menu-editor-card__preview">',
          '<span class="app-menu-editor-card__preview-icon">',
          renderIconMarkup(descriptor),
          '</span>',
          '<div class="app-menu-editor-card__meta">',
          '<strong>',
          escapeHtml(humanizeKey(iconKey)),
          '</strong>',
          '</div>',
          '</div>',
          '<button type="button" class="btn btn-outline-primary" data-pick-icon="',
          escapeHtml(item.configKey),
          '" data-pick-label="',
          escapeHtml(label),
          '" ',
          canEdit ? '' : 'disabled',
          '>',
          canEdit
            ? 'Trocar ícone'
            : locked
            ? 'Atualize o app para editar'
            : 'Troca disponível nas coleções personalizáveis',
          '</button>',
          '</article>',
        ].join('');
      })
      .join('');
  }

  function renderAll() {
    renderTabs();
    renderSummaryBadges();
    renderThemeControls();
    renderPaletteItems();
    renderThemeCards();
    renderPreviewStage();
    renderFloatIconSelect();
    renderFloatButtonCardPreview();
    renderMenuIconCards();
  }

  function showToast(message, type) {
    if (state.handlers && typeof state.handlers.toast === 'function') {
      state.handlers.toast(message, type || 'info');
      return;
    }
    if (window.NioApp && typeof window.NioApp.Toast === 'function') {
      window.NioApp.Toast(message, type || 'info');
    }
  }

  function persistTheme(nextThemeValue) {
    if (typeof state.handlers.saveTheme === 'function') {
      state.handlers.saveTheme(nextThemeValue);
    }
    state.config.menu.theme = nextThemeValue;
    state.theme = resolveTheme(nextThemeValue);
    renderAll();
  }

  function selectFamily(familyId) {
    if (state.disabled) {
      return;
    }
    if (isFamilyLocked(familyId)) {
      showToast('Atualize o app para liberar essa coleção de ícones.', 'warning');
      return;
    }
    const next = composeThemeValue(
      familyId,
      state.theme.dark,
      familyId === 'phosphor' ? state.theme.variant : 'regular'
    );
    persistTheme(next);
    showToast('Coleção de ícones atualizada.', 'success');
  }

  function handleDarkToggle() {
    if (state.disabled) {
      return;
    }
    const nextTheme = composeThemeValue(state.theme.familyId, !!state.dom.darkToggle.checked, state.theme.variant);
    persistTheme(nextTheme);
  }

  function handlePhosphorVariant(variant) {
    if (state.disabled || isFamilyLocked('phosphor')) {
      return;
    }
    const nextTheme = composeThemeValue('phosphor', state.theme.dark, variant);
    persistTheme(nextTheme);
  }

  function getModalInstance() {
    if (state.bootstrapModal) {
      return state.bootstrapModal;
    }
    if (window.bootstrap && typeof window.bootstrap.Modal === 'function' && state.dom.iconPickerModal) {
      state.bootstrapModal = new window.bootstrap.Modal(state.dom.iconPickerModal);
    }
    return state.bootstrapModal;
  }

  function openPicker(configKey, label) {
    if (state.disabled || !isCustomFamily(state.theme.familyId) || isFamilyLocked(state.theme.familyId)) {
      return;
    }
    state.modal.targetKey = configKey;
    state.modal.targetLabel = label;
    state.modal.category = 'all';
    state.modal.search = '';
    if (state.dom.iconPickerSearch) {
      state.dom.iconPickerSearch.value = '';
    }
    renderPicker();
    const modal = getModalInstance();
    if (modal) {
      modal.show();
    } else if (state.dom.iconPickerModal) {
      state.dom.iconPickerModal.style.display = 'block';
      state.dom.iconPickerModal.classList.add('show');
    }
  }

  function closePicker() {
    const modal = getModalInstance();
    if (modal) {
      modal.hide();
      return;
    }
    if (state.dom.iconPickerModal) {
      state.dom.iconPickerModal.style.display = 'none';
      state.dom.iconPickerModal.classList.remove('show');
    }
  }

  function renderPicker() {
    if (!state.dom.iconPickerGrid || !state.dom.iconPickerCategories || !state.dom.iconPickerTitle) {
      return;
    }

    const list = getFamilyList(state.theme);
    const selectedKey = state.config.menu[state.modal.targetKey] || 'gift';
    const categories = Array.from(new Set(list.map((item) => item.category))).sort();
    const search = (state.modal.search || '').trim().toLowerCase();

    state.dom.iconPickerTitle.textContent =
      state.modal.targetLabel + ' - Estilo ' + getFamilyById(state.theme.familyId).label;
    state.dom.iconPickerCategories.innerHTML = [
      '<button type="button" class="app-menu-chip is-interactive ',
      state.modal.category === 'all' ? 'is-active' : '',
      '" data-picker-category="all">Todos</button>',
      categories
        .map(
          (category) =>
            '<button type="button" class="app-menu-chip is-interactive ' +
            (state.modal.category === category ? 'is-active' : '') +
            '" data-picker-category="' +
            escapeHtml(category) +
            '">' +
            escapeHtml(category) +
            '</button>'
        )
        .join(''),
    ].join('');

    const filtered = list.filter((item) => {
      if (state.modal.category !== 'all' && item.category !== state.modal.category) {
        return false;
      }
      if (!search) {
        return true;
      }
      const haystack = (item.key + ' ' + item.category + ' ' + humanizeKey(item.key)).toLowerCase();
      return haystack.includes(search);
    });

    if (!filtered.length) {
      state.dom.iconPickerGrid.innerHTML = '';
      state.dom.iconPickerEmpty.hidden = false;
      return;
    }

    state.dom.iconPickerEmpty.hidden = true;
    state.dom.iconPickerGrid.innerHTML = filtered
      .map((item) => {
        const descriptor = normalizeCatalogDescriptor(state.theme, item, item.key, false);
        return [
          '<button type="button" class="app-menu-icon-option ',
          selectedKey === item.key ? 'is-selected' : '',
          '" data-picker-icon="',
          escapeHtml(item.key),
          '">',
          '<span class="app-menu-icon-option__preview">',
          renderIconMarkup(descriptor),
          '</span>',
          '<span class="app-menu-icon-option__label">',
          escapeHtml(humanizeKey(item.key)),
          '</span>',
          '</button>',
        ].join('');
      })
      .join('');
  }

  function saveMenuIcon(iconKey) {
    const targetKey = state.modal.targetKey;
    if (!targetKey) {
      return;
    }

    if (typeof state.handlers.saveMenuIcon === 'function') {
      state.handlers.saveMenuIcon(targetKey, iconKey);
    }
    state.config.menu[targetKey] = iconKey;
    renderAll();
    closePicker();
    showToast('Ícone atualizado com sucesso.', 'success');
  }

  function saveMenuOrder() {
    if (state.disabled) {
      return;
    }

    const labels = getCurrentMenuLabels();
    if (labels.includes('Menu') && !isSidebarVersionSupported()) {
      showToast('Solicite uma atualização do app para ativar o menu lateral.', 'warning');
      return;
    }
    if (labels.length < 4 || labels.length > 6) {
      showToast('Escolha entre 4 e 6 opções para o menu inferior.', 'error');
      return;
    }

    if (typeof state.handlers.saveMenuOptions === 'function') {
      state.handlers.saveMenuOptions(labels);
    }
    if (!isFloatBtnEligible(labels) && state.config.menu.floatBtnIndex === 2) {
      state.config.menu.floatBtnIndex = -1;
      if (typeof state.handlers.saveFloatBtnIndex === 'function') {
        state.handlers.saveFloatBtnIndex(-1);
      }
    }
    state.config.menu.options = labels;
    renderAll();
    showToast('Ordem do menu salva.', 'success');
  }

  function handleTabKeydown(event) {
    const currentButton = event.target.closest('[data-app-menu-tab]');
    if (!currentButton) {
      return;
    }

    const currentIndex = APP_MENU_TAB_IDS.indexOf(currentButton.getAttribute('data-app-menu-tab'));
    if (currentIndex < 0) {
      return;
    }

    let nextIndex = currentIndex;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (currentIndex + 1) % APP_MENU_TAB_IDS.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (currentIndex - 1 + APP_MENU_TAB_IDS.length) % APP_MENU_TAB_IDS.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = APP_MENU_TAB_IDS.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    const nextTab = APP_MENU_TAB_IDS[nextIndex];
    setActiveTab(nextTab);
    const nextButton = state.dom.tabs.querySelector('[data-app-menu-tab="' + nextTab + '"]');
    if (nextButton) {
      nextButton.focus();
    }
  }

  function bindEvents() {
    if (state.dom.tabs) {
      state.dom.tabs.addEventListener('click', function (event) {
        const button = event.target.closest('[data-app-menu-tab]');
        if (!button) {
          return;
        }
        setActiveTab(button.getAttribute('data-app-menu-tab'));
      });

      state.dom.tabs.addEventListener('keydown', handleTabKeydown);
    }

    state.dom.themeFamilyGrid.addEventListener('click', function (event) {
      const variantButton = event.target.closest('[data-phosphor-variant]');
      if (variantButton) {
        handlePhosphorVariant(variantButton.getAttribute('data-phosphor-variant'));
        return;
      }

      const card = event.target.closest('[data-theme-family]');
      if (!card) {
        return;
      }
      selectFamily(card.getAttribute('data-theme-family'));
    });

    state.dom.darkToggle.addEventListener('change', handleDarkToggle);

    state.dom.menuIconEditor.addEventListener('click', function (event) {
      const button = event.target.closest('[data-pick-icon]');
      if (!button) {
        return;
      }
      openPicker(button.getAttribute('data-pick-icon'), button.getAttribute('data-pick-label'));
    });

    state.dom.iconPickerCategories.addEventListener('click', function (event) {
      const button = event.target.closest('[data-picker-category]');
      if (!button) {
        return;
      }
      state.modal.category = button.getAttribute('data-picker-category');
      renderPicker();
    });

    state.dom.iconPickerGrid.addEventListener('click', function (event) {
      const button = event.target.closest('[data-picker-icon]');
      if (!button) {
        return;
      }
      saveMenuIcon(button.getAttribute('data-picker-icon'));
    });

    state.dom.iconPickerSearch.addEventListener('input', function (event) {
      state.modal.search = event.target.value || '';
      renderPicker();
    });

    state.dom.saveMenu.addEventListener('click', saveMenuOrder);

    if (state.dom.iconPickerModal) {
      state.dom.iconPickerModal.addEventListener('click', function (event) {
        if (event.target === state.dom.iconPickerModal) {
          closePicker();
        }
      });
    }
  }

  function startObserver() {
    if (state.dragObserver || !state.dom.basicLeft || !state.dom.basicRight) {
      return;
    }

    state.dragObserver = new MutationObserver(function () {
      if (state.isSyncingPalette) {
        return;
      }
      window.requestAnimationFrame(function () {
        renderAll();
      });
    });

    state.dragObserver.observe(state.dom.basicLeft, { childList: true });
    state.dragObserver.observe(state.dom.basicRight, { childList: true });
  }

  function bindLayoutObservers() {
    syncStickyTop();
    window.addEventListener('resize', syncStickyTop);
    window.addEventListener('load', syncStickyTop);

    if (window.ResizeObserver && !state.headerResizeObserver) {
      const header = document.querySelector('.nk-header');
      if (header) {
        state.headerResizeObserver = new window.ResizeObserver(syncStickyTop);
        state.headerResizeObserver.observe(header);
      }
    }
  }

  function cacheDom() {
    state.dom.root = document.getElementById('appMenuEditorRoot');
    state.dom.tabs = document.getElementById('appMenuTabs');
    state.dom.tabButtons = Array.from(document.querySelectorAll('[data-app-menu-tab]'));
    state.dom.tabPanels = Array.from(document.querySelectorAll('[data-app-menu-panel]'));
    state.dom.catalogSummary = document.getElementById('appMenuCatalogSummary');
    state.dom.darkToggle = document.getElementById('appMenuDarkToggle');
    state.dom.currentThemeMeta = document.getElementById('appMenuCurrentThemeMeta');
    state.dom.themeFamilyGrid = document.getElementById('themeFamilyGrid');
    state.dom.previewStage = document.getElementById('themePreviewStage');
    state.dom.floatBtnPreview = document.getElementById('floatbtn');
    state.dom.floatBtnPreviewIcon = document.getElementById('floatBtnPreviewIcon');
    state.dom.floatBtnPreviewText = document.getElementById('floatBtnPreviewText');
    state.dom.floatBtnIconSelect = document.getElementById('floatBtnIconSelect');
    state.dom.menuIconEditor = document.getElementById('menuIconEditor');
    state.dom.basicLeft = document.getElementById('basicLeft');
    state.dom.basicRight = document.getElementById('basicRight');
    state.dom.saveMenu = document.getElementById('saveMenu');
    state.dom.iconPickerModal = document.getElementById('iconPickerModal');
    state.dom.iconPickerTitle = document.getElementById('iconPickerTitle');
    state.dom.iconPickerSearch = document.getElementById('iconPickerSearch');
    state.dom.iconPickerCategories = document.getElementById('iconPickerCategories');
    state.dom.iconPickerGrid = document.getElementById('iconPickerGrid');
    state.dom.iconPickerEmpty = document.getElementById('iconPickerEmpty');
  }

  function init(options) {
    const nextOptions = options || {};
    state.disabled = !!nextOptions.disabled;
    state.appVersion = Number(nextOptions.appVersion) || getStoredAppVersion();
    state.handlers = nextOptions.handlers || {};
    state.floatDraft = {};

    if (!state.initialized) {
      cacheDom();
      if (!state.dom.root) {
        return;
      }
      state.activeTab = normalizeTabId(
        (state.dom.tabs && state.dom.tabs.querySelector('.app-menu-tab.is-active')?.getAttribute('data-app-menu-tab')) || state.activeTab
      );
      bindEvents();
      startObserver();
      bindLayoutObservers();
      state.initialized = true;
    }

    renderAll();
  }

  function sync(config) {
    state.config = normalizeConfig(config);
    state.appVersion = Number(state.config.appVersion) || getStoredAppVersion();
    state.floatDraft = {};
    state.theme = resolveTheme(state.config.menu.theme);
    syncPalette(state.config.menu.options);
    renderAll();
  }

  function previewFloatButton(patch) {
    state.floatDraft = {
      ...(state.floatDraft || {}),
      ...(patch || {}),
    };
    renderThemeCards();
    renderPreviewStage();
    renderFloatIconSelect();
    renderFloatButtonCardPreview();
  }

  window.AppMenuEditor = {
    init,
    sync,
    previewFloatButton,
  };
})();
